/**
 * Currency conversion for mobile app.
 * API and all calculations use cents; use these helpers when sending to API
 * or when displaying amounts in EUR to the user.
 */
const CENTS_PER_EUR = 100;

/**
 * Convert cents to EUR for display.
 * @param cents Amount in cents (e.g. 1050)
 * @returns Amount in EUR (e.g. 10.5) or 0 if invalid
 */
export function centsToEur(cents: number | undefined | null): number {
  if (cents == null || isNaN(cents)) {
    return 0;
  }
  return Math.round(cents) / CENTS_PER_EUR;
}

/**
 * Convert EUR to cents for API / calculations.
 * @param eur Amount in EUR (e.g. 10.5)
 * @returns Amount in cents (e.g. 1050) or 0 if invalid
 */
export function eurToCents(eur: number | undefined | null): number {
  if (eur == null || isNaN(eur)) {
    return 0;
  }
  return Math.round(eur * CENTS_PER_EUR);
}
